<template>
  <div>
    <h5 class="large_title">轻松一步完成注册</h5>
    <p class="sub_title">咨询专线： 400-108-1833</p>
    <StepBar :step="1"></StepBar>
    <LoginForm v-model="formData" :formType="1" @fn-handle="changeNextStatus">
      <ad-button class="sure_btn" :disabled="!enableNext" @click="registAction">下一步</ad-button>
      <p class="has_account">已有账号<a class="high_light" @click="goUrl('/login')">去登录</a></p>
    </LoginForm>
  </div>
</template>

<script type="text/javascript">
import StepBar from '@/components/TheLogonStepBar'
import { phoneReg, passwordReg } from '@/utils/fn'
import LoginForm from './LoginForm'
import { registUser } from '@/utils/customerApi'

export default {
  name: 'RegistUser',
  components: { StepBar, LoginForm },
  data () {
    return {
      formData: {
        phoneNumber: '', // 注册手机号
        smsVerifyCode: '', // 短信验证码
        password: '',
        confirmPassword: ''
      },
      enableNext: false
    }
  },
  methods: {
    changeNextStatus (status) {
      this.enableNext = status
    },
    async registAction () {
      const { phoneNumber, smsVerifyCode, password, confirmPassword } = this.formData
      if (!phoneReg.test(phoneNumber)) return this.messageTip('请输入正确的手机号')
      if (!passwordReg.test(password)) return this.messageTip('请输入8~20位含有大小写字母和数字的密码')
      if (confirmPassword !== password) return this.messageTip('请再次输入相同的密码')

      let opt = await this.encryptorProto({ password, confirmPassword })
      if (opt) {
        opt.phoneNumber = phoneNumber
        opt.smsVerifyCode = this.encode(smsVerifyCode)
        // opt.guid = 0 // 邀请人guid
        // opt.inviteCode = '' // 邀请码
        let res = await registUser(opt)
        if (res && res.code === 0 && res.data) {
          tzx_czcPush('register', phoneNumber, 1)
          if (res.data.token) localStorage.setItem('user_ticket', res.data.token)
          localStorage.setItem('TzxUid', res.data.id)
          this.$store.commit('customer/setUserInfo', { ...res.data })
          this.$emit('next-step')
        } else {
          tzx_czcPush('register', phoneNumber, 0)
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.large_title
  margin: 40px auto 6px
  color: #282729
  font-size: 28px
  line-height: 40px
  font-weight: 600
  text-align: center
.sub_title
  margin-bottom: 20px
  color: #999
  font-size: 16px
  line-height: 22px
  text-align: center
.sure_btn
  margin-top: 30px !important
.has_account
  margin-top: 20px
  font-size: 14px
  line-height: 20px
  text-align: center
  .high_light
    cursor: pointer
    color: $main-color
    margin: 0 4px
</style>